import SourcePopover from 'src/components/ui/SourcePopover';
import type { PamQuestionRef } from '../api/types';

/** A "PAM {ref}" pill that previews the question's text on hover. */
export default function PamQuestionPill({ question }: { question: PamQuestionRef }) {
  return (
    <SourcePopover
      content={question.text}
      source={{
        title: question.ref,
        jurisdiction: [question.domain_name, question.saq_name].filter(Boolean).join(' · ')
      }}
      pageInfo="NHS PAM"
      clickable={false}
      compactTrigger
    >
      <button
        type="button"
        className="inline-flex max-w-[180px] items-center rounded-full bg-surface-hover px-2 py-0.5 text-xs font-medium text-content-subtle hover:bg-bluegray-100"
        // Keeps the click from reaching a clickable ancestor, such as a table row.
        onClick={(event) => event.stopPropagation()}
      >
        <span className="truncate lining-nums">PAM {question.ref}</span>
      </button>
    </SourcePopover>
  );
}
